module.exports = __webpack_public_path__ + "static/housewrk-c1b10863bef4da50cb7181ef08e89837.mp4";